
import './App.css';
import Google from './Google';

function App() {
  return (
    <div className="App">
    <Google />
    </div>
  );
}

export default App;
